/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPanelTop: {
  name: 'panel-top';
  data: string;
} = {
  name: 'panel-top',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm14 5V5H5v3h14ZM5 10h14v9H5v-9Z" fill="currentColor"/></svg>`,
};
